import { Category } from '~/service/api'

export class CustomCategory extends Category {
  constructor(data: undefined | any = {}) {
    super()
    this.id = data.id || null
    this.title = data.title || null
  }
}
